import { Container, Grid, Typography, makeStyles } from "@material-ui/core";

export const ShopRegionHeadline = (props: any) => {
  const classes = useStyles();
  const { data, headlineTypeSingular, headLineTypePlural } = props;

  return (
    <Container className={classes.root}>
      <Grid item container xs={12} alignItems="baseline">
        <Typography variant="subtitle2" component="h2" color="textPrimary">
          {data?.header ?? ""}
        </Typography>
        <Typography
          variant="caption"
          component="span"
          color="textSecondary"
          className={classes.headLine}
        >
          {`${data?.count ?? 0} ${
            data?.count === 1
              ? `${headlineTypeSingular ?? "Shop"}`
              : `${headLineTypePlural ?? "Shops"}`
          }`}
        </Typography>
      </Grid>
    </Container>
  );
};
const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    justifyContent: "start",
    padding: 24,
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  headLine: {
    marginLeft: 8,
    fontWeight: 400,
  },
}));
